import type { ChangeSolutionStepsType } from "app/components/ChangeSolutionModal/consts";
import type { ValueOf } from "pro-features/types";

export interface IStepButtonConfig {
    showBack?: boolean;
    showNext?: boolean;
    showSkip?: boolean;
    nextButtonDisabled?: boolean;
}

export interface IStepConfig {
    id: ChangeSolutionStepsType;
    title: string;
    subTitle: string;
    trackingEventName: string;
    importantText?: string;
    isLastStep?: boolean;
    buttons?: IStepButtonConfig;
}

export interface IStepScreenProps {
    config: IStepConfig;
}

export const USE_CASE_GROUPS = {
    analyzeWebsite: "Analyze websites and market trends",
    improveSEO: "Improve SEO and PPC",
    analyzeApps: "Analyze app competitors and mobile trends",
    findLeads: "Find leads and personalize outreach",
    exploreAmazon: "Explore Amazon's marketplace demand",
} as const;

export type UseCaseGroupKey = keyof typeof USE_CASE_GROUPS;

export type UseCaseGroupLabel = ValueOf<typeof USE_CASE_GROUPS>;

export const SolutionType = {
    sales: "sales-solution",
    shopper: "shopper-solution",
    marketing: "web-solution",
    apps: "app-solution",
} as const;

export type SolutionType = (typeof SolutionType)[keyof typeof SolutionType];

export interface IUseCaseStepConfig {
    title: string;
    value: UseCaseGroupLabel;
    solution: SolutionType;
}
